import './UploadForm.css'
import * as _ from 'lodash'
import { useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'
import Context from '../../context/Context'
// import Lottie from '../lottie/lottie/loading'
import Lottie from '../../Components/lottie/lottie/loading'

function Uploader({ setUploading, setdetails }) {
  const [uploadStart, setUploadStart] = useState(false)
  const [progressbar, setProgressbar] = useState()
  const { data, pinData, setUploadSucccess } = useContext(Context)
  const gcpUrl = pinData.data.data.videoUploadURL
  const contestIdData = window.location.pathname.split('/')[3]
  const campaignIdData = window.location.pathname.split('/')[2]
  const navigate = useNavigate()
  useEffect(() => {
    uploadVideo(gcpUrl)
  }, [])
  const uploadVideo = async (payload) => {
    try {
      setUploadStart(true)
      //upload as binary function
      const uploadGcp = (file, url) => {
        var xhr = new XMLHttpRequest()
        xhr.open('PUT', url, true)
        xhr.setRequestHeader('Content-type', file.type)
        xhr.onload = (response) => { }
        xhr.onreadystatechange = async () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              // setUploadSucccess(true)
              // navigate(
              //   `/${campaignIdData}/${contestIdData}/participate/uploading/details`,
              // )
              setUploading(false)
              setdetails(true)
            } else {
              navigate('error')
            }
          }
        }
        xhr.onerror = function (response) {
          console.log('Response error', response)
        }
        xhr.upload.onprogress = function (evt) {
          // For uploads
          if (evt.lengthComputable) {
            let percentComplete = parseInt((evt.loaded / evt.total) * 100)
            setProgressbar(percentComplete)
            //console.log('progress', percentComplete);
          }
        }
        xhr.send(file)
      }

      const response3 = await uploadGcp(data, payload)
      return response3
    } catch (error) {
      console.log(error.message)
      navigate('error')
    }
  }

  return (
    uploadStart && (
      <div>
        <Lottie progressbar={progressbar}/>
      </div>
    )
  )
}

export default Uploader
